var style = {"z-autoshipment-logo-mark":"z-autoshipment-logo-mark","z-autoshipment-logo-mark--medium":"z-autoshipment-logo-mark--medium","z-autoshipment-logo-mark--light":"z-autoshipment-logo-mark--light"};

export { style as default };
//# sourceMappingURL=AutoshipmentLogoMark.module.scss.js.map
